import React from 'react';
import { connect } from 'react-redux';
import { DropdownButton, MenuItem, Col, Row } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import {
  find as _find,
  findIndex as _findIndex,
  uniqBy as _uniqBy,
  groupBy as _groupBy,
  values as _values,
} from 'lodash';

import { getNameInCurrentLanguage } from 'helpers/intl';
import { getVariantValueFormated } from 'helpers/items';

class ItemVariantSelectors extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedAttributes: [],
    };
  }

  componentDidUpdate = prevProps => {
    const { selectedVariant } = this.props;

    if (prevProps.selectedVariant !== selectedVariant) {
      this.setState({ selectedAttributes: this.getSelectedAttributes(selectedVariant) });
    }
  };

  getSelectedAttributes = selectedVariant => {
    return selectedVariant.attributes
      .map(attibute => {
        return attibute.values.map(val => {
          return { id: attibute.id, valueId: val.id };
        });
      })
      .reduce((acc, variantAttrs) => acc.concat(variantAttrs), []);
  };

  mapAttrToOption = attr => {
    const {
      appIntl,
      intl: { messages },
    } = this.props;
    const { selectedAttributes } = this.state;

    return {
      id: attr.id,
      name: getNameInCurrentLanguage(attr.name, appIntl),
      values: attr.values.map(value => {
        return {
          id: value.id,
          name: getVariantValueFormated(value, appIntl, messages),
          type: value.value[0].type,
          isSelected: _find(selectedAttributes, ['valueId', value.id]) ? true : false,
        };
      }),
    };
  };

  getAllVariations = variants => {
    return variants
      .map(variant => {
        return variant.attributes.map(this.mapAttrToOption);
      })
      .reduce((acc, variantAttrs) => acc.concat(variantAttrs), []);
  };

  getVariantOption = variants => {
    const allVariations = this.getAllVariations(variants);

    return _values(_groupBy(allVariations, 'id')).map(attrVariations => ({
      id: attrVariations[0].id,
      name: attrVariations[0].name,
      values: _uniqBy(attrVariations.reduce((acc, variation) => acc.concat(variation.values), []), 'id'),
    }));
  };

  getSelectedVariantOption = variantOptions => {
    const {
      intl: { messages },
    } = this.props;

    const selectedOption = _find(variantOptions.values, ['isSelected', true]);

    if (selectedOption) {
      return selectedOption.name;
    }

    return messages.select;
  };

  onSelect = (attrId, newValueId) => {
    const { changeVariant, variants } = this.props;
    const currentAttributes = this.getCurrentAttributes(attrId, newValueId);

    const selectedVariant = variants.find(variant => {
      return currentAttributes.reduce((acc, { id, valueId }) => {
        const attr = variant.attributes.find(attr => attr.id === id);

        return acc && attr && attr.values.find(({ id }) => id === valueId);
      }, true);
    });

    changeVariant(selectedVariant);
  };

  getCurrentAttributes = (attrId, newValueId) => {
    let { selectedAttributes } = this.state;

    if (selectedAttributes.length > 0 && attrId && newValueId) {
      const index = _findIndex(selectedAttributes, ['id', attrId]);
      selectedAttributes[index].valueId = newValueId;
    } else {
      selectedAttributes = this.getAttributesFromSelectedVariant(attrId, newValueId);
    }

    return selectedAttributes;
  };

  getAttributesFromSelectedVariant = (attrId, newValueId) => {
    const { selectedVariant } = this.props;

    const newAttributes = selectedVariant.attributes
      .map(attr => {
        return attr.values.map(val => {
          if (attr.id === attrId) {
            return { id: attr.id, valueId: newValueId };
          }

          return { id: attr.id, valueId: val.id };
        });
      })
      .reduce((acc, variantAttrs) => acc.concat(variantAttrs), []);

    return newAttributes;
  };

  getVariants = () => {
    const { variants } = this.props;

    return this.getVariantOption(variants).map(option => (
      <Col lg={2} key={option.id}>
        <div>
          <b>{option.name}</b>
        </div>

        <DropdownButton
          className="no-border bg-transparent"
          id="quote-vat-rate-dropdown"
          title={this.getSelectedVariantOption(option)}
          pullRight
          onSelect={val => this.onSelect(option.id, val)}
        >
          {option.values.map(value => (
            <MenuItem key={value.id} eventKey={value.id}>
              {value.name}
            </MenuItem>
          ))}
        </DropdownButton>
      </Col>
    ));
  };

  componentDidMount = () => {
    this.onSelect(null, null);
  };

  render() {
    return <Row>{this.getVariants()}</Row>;
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(ItemVariantSelectors));
